import { IDefer } from "src/constants/interfaces";
import { useTranslation } from "src/hooks/translation";

interface IProps {
    defer: IDefer<boolean>;
};

const ClearBetslipPopup = ({ defer }: IProps) => {
    const t = useTranslation();

    return (
        <div className="B-popup-content B-popup-small">
            <h3 className="B-popup-title">{t('Clear Betslip')}</h3>
            <div className="B-popup-main-content">
                <i className="global-icon icon-recycle-bin2 B-icon"/>
                <p className="text-center">{t('Are you sure you want to clear betslip?')}</p>
            </div>

            <button className="B-popup-cancel-button" onClick={() => defer.resolve(false)}>{t('Cancel')}</button>
            <button className="B-popup-confirm-button" onClick={() => defer.resolve(true)}>{t('Clear')}</button>
        </div>
    );
};

export default ClearBetslipPopup;
